import "@/App.css";

import SmoothScroll from "./homestay/SmoothScroll";
import Navbar from "./homestay/Navbar";
import Hero from "./homestay/Hero";
import Marquee from "./homestay/Marquee";
import About from "./homestay/About";
import Rooms from "./homestay/Rooms";
import Campfire from "./homestay/Campfire";
import MalnadFood from "./homestay/MalnadFood";
import Reviews from "./homestay/Reviews";
import Attractions from "./homestay/Attractions";
import BookingForm from "./homestay/BookingForm";
import Contact from "./homestay/Contact";
import Footer from "./homestay/Footer";
import FloatingButtons from "./homestay/FloatingButtons";

function App() {
  return (
    <div className="App min-h-screen bg-[color:var(--paper)] text-[color:var(--ink)] overflow-x-hidden max-w-full">
      {/* Visually-hidden semantic H1 for SEO/accessibility.
          The visible hero uses a decorative headline; this ensures the
          page keeps ONE clear H1 matching the business name. */}
      <h1
        className="sr-only"
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0,0,0,0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        Hashtag Sakleshpura Homestay — Coffee Estate Stay in Hiridanahalli, Karnataka
      </h1>
      <SmoothScroll />
      <Navbar />
      <main>
        <Hero />
        <Marquee items={["Stay", "Relax", "Explore", "Sakleshpura", "Western Ghats", "Coffee Country", "Malnad"]} />
        <About />
        <Rooms />
        <Campfire />
        <MalnadFood />
        <Marquee
          items={["Malnad Dosa", "Chicken Curry", "Kadubu", "Idly", "Filter Coffee"]}
          invert
        />
        <Reviews />
        <Attractions />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
